import React from 'react'

// core components
import GridContainer from '../../components/Grid/GridContainer.js'
import GridItem from '../../components/Grid/GridItem.js'
import Card from '../../components/Card/Card.js'
import CardIcon from '../../components/Card/CardIcon.js'
import CardHeader from '../../components/Card/CardHeader.js'

// material-ui components
// import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'

// Icons
import BusinessIcon from '@material-ui/icons/Business'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'

// components
import SiteSelector from '../Common/SiteSelector.js'
import ButtonWithTooltip from 'components/ButtonWithTooltip/ButtonWithTooltip.js'

// report components
import { dashboardResponse } from '../../layouts/Aws.js'

export default function SiteProducts () {
  const [siteList, setSiteList] = React.useState()
  const [selectedSiteId, setSelectedSiteId] = React.useState(null)

  React.useEffect(() => {
    dashboardResponse().then(res => {
      const shopmateSites = []

      for (const site of res.sites) {
        if (site.code === 'S') {
          shopmateSites.push(site)
        }
      }

      setSiteList(shopmateSites)
    })
  }, [])

  const onSiteSelected = async (newSite) => {
    setSelectedSiteId(newSite)
  }

  const onLoadBackOfficeClick = () => {
    const backOfficeUrl = getBackOfficeUrl(selectedSiteId)

    window.location.href = backOfficeUrl
  }

  const onLoadBackOfficeInNewWindowClick = () => {
    const backOfficeUrl = getBackOfficeUrl(selectedSiteId)

    window.open(backOfficeUrl, '_blank').focus()
  }

  const getBackOfficeUrl = (siteId) => {
    let backOfficeUrl = null

    for (const site of siteList) {
      if (siteId === site.id) {
        const shopId = site.display_id.slice(-4)
        const lastDigit = shopId.slice(-1)

        backOfficeUrl = `https://1.${shopId}.shopmate${lastDigit}.co.uk/BackOffice`

        break
      }
    }

    return (backOfficeUrl)
  }

  return (
    <>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="danger" icon>
              <GridContainer>
                <GridItem xs={3} sm={3}>
                  <CardIcon color="danger">
                    <BusinessIcon />
                  </CardIcon>
                </GridItem>
                <GridItem xs={8} sm={8}>
                  <GridContainer alignItems="center">
                    <GridItem xs={8} sm={8}>
                      <SiteSelector
                        siteList={siteList}
                        onSelect={onSiteSelected}
                        isGridItem={false}
                        autoSelect={false}
                      />
                    </GridItem>
                    <GridItem xs={4} sm={4}>
                      <ButtonGroup>
                        <ButtonWithTooltip tooltipText= "Go to BackOffice" variant="contained" color="primary" onClick={onLoadBackOfficeClick} disabled={selectedSiteId === null}>Load BackOffice</ButtonWithTooltip>
                        <ButtonWithTooltip tooltipText="Open BackOffice in new tab" variant="contained" color="primary" onClick={onLoadBackOfficeInNewWindowClick} disabled={selectedSiteId === null}><OpenInNewIcon style={{ height: '20px', marginBottom: '5px', marginRight: '-10px', marginLeft: '-10px' }} /></ButtonWithTooltip>
                      </ButtonGroup>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </CardHeader>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  )
}
